module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/leather_81fa97.jpg";